<template>
  <div class="index">
 <Title titleName='商家中心' iconLeft="back"/>
<div class="icon-yu">
	<h3>￥{{title}}</h3>
	<p>累计提现金额（元）</p>
	
	
</div>




	<div class="index-product">
		
		<div class="con">
			<ul>
				
				<li v-for="item in news">
						
				<div class="tis">
					<img src="../../assets/user_service.png" />
					<div class="txt">
						<h5>{{item.title}}<span v-if="item.state==0">审核中</span><span v-if="item.state==1">成功</span><span v-if="item.state==2">失败</span></h5>
						<p>{{item.created_at}}</p>
					</div>
				</div>
					<div class="mon">{{item.money}}</div>
					</li>
		
			
			</ul>
			
		</div>
		
	</div>



  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
export default {
  components: {
    Title
  },
  data() {
    return {
		title:'',
		channel_id:0,
		images:[],
		info:'',
		page:1,
		news:[],
		notice:[],
		name:'',
		hans:'',
		sfznum:'',
		phone:'',
		tip:''

    };
  },  mounted() {
 
	this.sandMate();
	this.sandRed();
		
		
		},methods: {
		
		sandMate(){
			
			this.$axios({
			  method: "get",
			  url: "stores/withdraw_list"
			}).then((res) => {
				let data=res.data;
		
				if(data.code==200){
				
					this.news=data.data.lists.data;
					this.title=data.data.total_money
					
					
				}
			 
			});
		
		},sandAlt(){
				this.news=[]
				this.page=1
				this.sandMate()
			
			}
		}
};
</script>
<style lang="scss" scoped>
.index {


  width: 100%;
  overflow: hidden;
   background: #F1F1F1;
}
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
	img{
		width: 100%;
	}

  }

  .info{
	padding: 30px;
	background: #F6F6F6;
	display: flex;
	justify-content: space-between;
	font-size: 24px;
	color: #808080;
	align-items: center;
	.more{
		  img{
			  width: 21px;
			  height: 36px;
		  }
		  
	}
	.l1{
		span{
			color: #2892FF;
			font-size: 28px;
			margin-right: 20px;
		}
	}
	.l2{
		line-height: 60px;
		display: flex;
		align-items: center;
		img{
			width: 33px;
			height: 24px;
			margin-right: 10px;
		}
	}
  }
  .menu{
	  margin-top: 30px;
	  ul{
		  display: flex;
		  flex-direction: row;
		  flex-wrap: wrap;
		  li{
			 width: 25%;
		
			 img{
				 width: 70%;
			 }
			 p{
				 line-height:70px;
			 }
		  }
	  }
	  
  }
  .notice{
	  background: #FFFFFF;
	  border-radius: 20px;
	  padding: 30px;
	  margin-top: 50px;
	  font-size: 28px;
	  display: flex;
	  align-items: center;
	  img{
		  width: 169px;
		  height: 46px;
		  margin-right: 30px;
	  }
  }
	
  .news{
	 background: #FFFFFF;
	 border-radius: 20px;
	 padding:30px 30px 0 30px;
	 margin-top: 50px;
	 font-size: 28px;
	 margin-bottom: 30px;
	 .tit{
		 display: flex;
		 justify-content: space-between;
		 align-items: center;
		 border-bottom: 1px solid #F1F1F1;
		 padding-bottom: 20px;
		 .more{
		 	  img{
		 		  width: 16px;
		 		  height:29px;
		 	  }
		 	  
		 }
		 .sub{
			 display: flex;
			 align-items: center;
			 color: #2892FF;
			 img{
				 width: 39px;
				 height: 40px;
				 margin-right: 20px;
			 }
			
		 }
	 }
	
	 .cont{
		 li{
			 border-bottom: 1px solid #F1F1F1;
			 display: flex;
			 padding: 30px 0;
			 text-align: left;
			 img{
				 width: 271px;
				 height: 193px;
				 margin-right: 20px;
			 }
			 h4{
				 outline: 1;
				 font-size: 30px;
			 }
			 p{
				 color: #7E7E7E;
				 font-size: 26px;
				 margin: 20px 0;
			 }
		 }
	 }
	 .cont2{
	 		ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				li{
					width: 30%;
					img{
						width: 100%;
						margin: 20px 0;
					}
					.txt{
						font-size: 24px;
						margin-bottom: 20px;
					}
				}
			}
	 }
	
  }
 .act-br{
 		 width:100%;
 		margin-top: 50rpx;
 		 img{
 			 width: 100%;
 		 }
 }
 .index-banner{
	 background-color: #FFFFFF;
 }
 .index-nav{
	 background: #000000;
	 color: #FFFFFF;
	  padding: 30px 0;
	  text-align: center;
	 ul{
		 display: flex;
	
		 justify-content:space-between;
		 li{
			 width: 100%;
		
			border-right: 1px solid #444444;
			
			 p{
				 line-height: 50px;
			 }
			 a{
				 color: #FFFFFF;
			 }
		 }
	 }
 }
 .index-nav2{
 	 background: #FFFFFF;
 	 color: #000000;
	 border-bottom: 1px solid #DDDDDD;
	   padding: 30px 0;
	   text-align: center;
 	 ul{
		
 		 display: flex;
 		 justify-content:space-evenly;
 		 li{
			width: 100%;
			border-right: 1px solid #DDDDDD;
 	
 			 p{
 				 line-height: 50px;
 			 }
			 .act{
				 color: #999999;
			 }
 		 }
 	 }
 }
 .index-product{
	margin-top: 20px;
	 font-size: 28px;
	 color: #000000;
	
	 .tit{
		 line-height: 60px;
		 display: flex;
		 align-items: center;
		 .zik{
			 width: 4px;
			 height: 28px;
			 background: #000000;
			 margin-right: 20px;
		 }
	 }
	 .con{
		
		 ul{
			 display: flex;
			 flex-wrap: wrap;
			 justify-content: space-between;
			 li{
				background: #ffffff;
				border-bottom: 1px solid #EEEEEE;
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 30px;
				.tis{
					display: flex;
					align-content: center;
					img{
						width: 90px;
						height: 90px;
						margin-right: 30px;
					}
					.txt{
						h5{
							font-size: 30px;
							font-weight: normal;
						}
						p{
							font-size: 28px;
							color: #AAAAAA;
							margin-top: 15px;
						}
					}
				}
				.mon{
					font-size: 30px;
					color: #FF5E00;
				}
			 }
		 }
		 .button{
			 width: 200px;
			 height: 60px;
			 background: #444444;
			color: #ffffff;
			text-align: center;
			line-height: 60px;
			margin: 20px auto;
			}
	 }
 }
 .index-bar{
	 img{
		 width: 100%;
	 }
 }
 .pro-tit{
	 background: #FFFFFF;
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }

 .can{
 	
 	border-bottom: 1px solid #EAEAEA;
 	display: flex;
 	justify-content: space-between;
 	height: 100px;
 	align-items: center;
	color: #7D7D7D;
	font-size: 24px;
	b{
		font-size: 28px;
		color: #00928F;
		font-weight: 400;
		margin-right: 20px;
	}
 
 }
 .can2{
 	border-bottom: 1px solid #EAEAEA;
 	padding: 20px 0;
 	img{
 		width: 100%;
 	}
 	p{
 		display: flex;
 		justify-content: space-between;
 		align-items: center;
 		margin-bottom:5px;
 	}
 }
 .can3{
	 padding: 20px 0;
	 .rit{
		 text-align: right;
		 button{
			 margin-left: 20px;
		 }
	 }
 }
 .icon-yu{
	text-align: center;
	background: url(../../assets/bg.png);
	padding: 30px;

	p{
		
		font-size: 24px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #ffffff;
		margin-bottom: 30px;
		

	}
	h3{
		
		font-size: 48px;
		font-family: PingFang SC;
		font-weight: 800;
		color:  #ffffff;
		margin: 30px 0;

	}


 }
</style>